import {
  type QSetReviewWorkflowStepCode,
  QSetReviewWorkflowStepCodeObject,
} from '@exam-management/task-management';
import { Tab, TabContext, TabList } from '@shared/components';

import { useQSetReviewTaskSearchParams } from '../../hooks';

// NOTE: This generic type is used for the type accept Type and contains string type for type context
interface TabItem<TValue extends string = string> {
  value: TValue;
  label: string;
}

type QSetReviewTaskStatusTabValues = QSetReviewWorkflowStepCode | 'ALL';

const TAB_LIST: TabItem<QSetReviewTaskStatusTabValues>[] = [
  {
    value: 'ALL',
    label: 'All',
  },
  {
    value: QSetReviewWorkflowStepCodeObject.QsetReviewTodo,
    label: 'Todo',
  },
  {
    value: QSetReviewWorkflowStepCodeObject.QsetReviewInReview,
    label: 'In Review',
  },
  {
    value: QSetReviewWorkflowStepCodeObject.QsetReviewReviewed,
    label: 'Reviewed',
  },
  {
    value: QSetReviewWorkflowStepCodeObject.QsetReviewDone,
    label: 'Done',
  },
];

export default function QsetReviewStatusFilter() {
  const [{ code }, { changeCode }] = useQSetReviewTaskSearchParams();

  const handleClick = (value: QSetReviewTaskStatusTabValues) => {
    changeCode(value);
  };

  return (
    <TabContext value={code ?? ''}>
      <TabList
        sx={(theme) => ({
          gap: theme.spacing(0),
          '& .MuiTabs-flexContainer': {
            gap: theme.spacing(0),
          },
        })}
      >
        {TAB_LIST.map((tab) => {
          return (
            <Tab
              sx={(theme) => ({
                borderRadius: theme.shape.rounded(0),
                p: theme.spacing(4, 4, 0, 4),
                minWidth: 'unset',
              })}
              key={tab.value}
              label={tab.label}
              value={tab.value}
              onClick={() => handleClick(tab.value)}
            />
          );
        })}
      </TabList>
    </TabContext>
  );
}
